import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance3j81i0dosd478 as Phases_getInstance,
} from './statement/HttpResponsePipeline.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instance17dpgmdbeabno as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance16mtoo1oa3tq as Phases_getInstance_0,
} from './request/HttpRequestPipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstance326p2fy5fh97r as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$intercept, call, $completion) {
  // Inline function 'kotlin.check' call
  if (!(call instanceof HttpClientCall())) {
    var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
    throw IllegalStateException().o(toString(message));
  }
  var tmp = $this.k5g_1.f5g_1.n4r(Unit_instance, call.q5g(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var response = tmp;
  call.r5g(response);
  var tmp_0 = $this$intercept.q4q(call, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$intercept, it, $completion) {
  try {
    var tmp = $this$intercept.r4q($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      $this.s5g_1.i5g_1.u4s(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.o4r_1.q5g(), cause));
      throw cause;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_execute__d6syw1($this, builder, $completion) {
  $this.i5g_1.u4s(get_HttpRequestCreated(), builder);
  var tmp = $this.c5g_1.n4r(builder, builder.w5g_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  return tmp_0 instanceof HttpClientCall() ? tmp_0 : THROW_CCE();
}
var HttpClient$slambdaClass;
function HttpClient$slambda() {
  if (HttpClient$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.k5g_1 = this$0;
      }
      z5g($this$intercept, call, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, call), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass = $;
  }
  return HttpClient$slambdaClass;
}
function HttpClient$slambda_0(this$0) {
  var i = new (HttpClient$slambda())(this$0);
  var l = ($this$intercept, call, $completion) => i.z5g($this$intercept, call, $completion);
  l.$arity = 2;
  return l;
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
var HttpClient$slambdaClass_0;
function HttpClient$slambda_1() {
  if (HttpClient$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.s5g_1 = this$0;
      }
      a5h($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.a5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClient$slambdaClass_0 = $;
  }
  return HttpClient$slambdaClass_0;
}
function HttpClient$slambda_2(this$0) {
  var i = new (HttpClient$slambda_1())(this$0);
  var l = ($this$intercept, it, $completion) => i.a5h($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      static b5h(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.w5f_1 = engine;
        $this.x5f_1 = userConfig;
        $this.y5f_1 = false;
        $this.z5f_1 = atomic$boolean$1(false);
        $this.a5g_1 = Job($this.w5f_1.ew().hd(Key_instance));
        $this.b5g_1 = $this.w5f_1.ew().om($this.a5g_1);
        $this.c5g_1 = new (HttpRequestPipeline())();
        $this.d5g_1 = new (HttpResponsePipeline())();
        $this.e5g_1 = new (HttpSendPipeline())();
        $this.f5g_1 = new (HttpReceivePipeline())();
        $this.g5g_1 = AttributesJsFn(true);
        $this.h5g_1 = $this.w5f_1.c5h();
        $this.i5g_1 = new (Events())();
        $this.j5g_1 = new (HttpClientConfig())();
        if ($this.y5f_1) {
          $this.a5g_1.hx((it) => {
            var tmp;
            if (!(it == null)) {
              cancel($this.w5f_1);
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
        }
        $this.w5f_1.d5h($this);
        var tmp = Phases_getInstance_0().i5h_1;
        $this.e5g_1.s4r(tmp, HttpClient$slambda_0($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.x5f_1;
        $this.j5g_1.r5h(get_HttpRequestLifecycle());
        $this.j5g_1.r5h(get_BodyProgress());
        $this.j5g_1.r5h(get_SaveBody());
        if ($this$with.o5h_1) {
          $this.j5g_1.s5h('DefaultTransformers', HttpClient$lambda);
        }
        $this.j5g_1.r5h(Plugin_getInstance());
        $this.j5g_1.r5h(get_HttpCallValidator());
        if ($this$with.n5h_1) {
          $this.j5g_1.r5h(get_HttpRedirect());
        }
        $this.j5g_1.t5h($this$with);
        if ($this$with.o5h_1) {
          $this.j5g_1.r5h(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.j5g_1);
        $this.j5g_1.d5h($this);
        var tmp_0 = Phases_getInstance().u5h_1;
        $this.d5g_1.s4r(tmp_0, HttpClient$slambda_2($this));
        return $this;
      }
      static z5h(engine, userConfig, manageEngine) {
        var $this = this.b5h(engine, userConfig);
        $this.y5f_1 = manageEngine;
        return $this;
      }
      ew() {
        return this.b5g_1;
      }
      a5i(builder, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_execute__d6syw1.bind(VOID, this, builder), $completion);
      }
      q6() {
        var success = this.z5f_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.g5g_1.w4m(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.d4n().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          var plugin = installedFeatures.w4m(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.q6();
          }
        }
        this.a5g_1.w12();
        if (this.y5f_1) {
          this.w5f_1.q6();
        }
      }
      toString() {
        return 'HttpClient[' + toString(this.w5f_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [CoroutineScope(), AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().z5h(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.b5i(config.m5h_1);
  var client = HttpClient().z5h(engine, config, true);
  var tmp_0 = ensureNotNull(client.b5g_1.hd(Key_instance));
  tmp_0.hx((it) => {
    engine.q6();
    return Unit_instance;
  });
  return client;
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
